var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodAndHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#65bc50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.9,191.37a46.4,46.4,0,0,0-12.3-33.23,42.24,42.24,0,0,0-29.7-13.66,43.31,43.31,0,0,0-32.13,12.69,12.57,12.57,0,0,1-17.52,0A43.07,43.07,0,0,0,151,144.49c-23.35.79-42.56,21.71-41.95,45.69A89.76,89.76,0,0,0,112.64,213l0,.05a.28.28,0,0,0,0,.09c6.2,18.71,25.32,59,34.73,68.95a25.71,25.71,0,0,0,28.7,5.77L185,284a17.87,17.87,0,0,1,14,0l9,3.86a25.55,25.55,0,0,0,10.09,2.06,26,26,0,0,0,18.62-7.84c10.26-10.57,29.2-51.1,35.85-73.64,0,0,0-.07,0-.11l0-.1A89.45,89.45,0,0,0,274.9,191.37ZM231,276.53a17.92,17.92,0,0,1-19.82,4l-9-3.85a25.8,25.8,0,0,0-20.32,0L173,280.48a17.68,17.68,0,0,1-19.74-3.93c-8-8.46-26.43-46.41-32.89-65.85A81.59,81.59,0,0,1,117.07,190c-.49-19.68,15.18-36.85,34.23-37.5a35.23,35.23,0,0,1,26.29,10.35,20.42,20.42,0,0,0,28.83,0,35.45,35.45,0,0,1,26.23-10.35,34.33,34.33,0,0,1,24.1,11.11,38.4,38.4,0,0,1,10.16,27.47,81.49,81.49,0,0,1-2.06,15.27C258,229.62,239.62,267.62,231,276.53Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.42,155.29a4.14,4.14,0,0,0,1.19-.18,46.51,46.51,0,0,0,30.57-58.24,4,4,0,0,0-5-2.63,46.57,46.57,0,0,0-30.57,58.24A4,4,0,0,0,189.42,155.29Zm25.16-51.93A38.55,38.55,0,0,1,192.2,146,38.59,38.59,0,0,1,214.58,103.36Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.65,244a4,4,0,0,1-2.83-1.17l-23.46-23.47a4,4,0,1,1,5.66-5.65l20.62,20.62L226.58,190a4,4,0,1,1,5.69,5.63l-46.78,47.19a4,4,0,0,1-2.83,1.19Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodAndHealth);
export default __webpack_public_path__ + "static/media/food-and-health.97293010d6ded5741086467e52a498fe.svg";
export { ForwardRef as ReactComponent };